import { z } from "zod/v4";

export const taskStatusSchema = z.enum(["open", "in_progress", "done"]);
export const taskPrioritySchema = z.enum(["low", "medium", "high"]);

export const taskSchema = z.object({
	id: z.string().uuid(),
	club_id: z.string().uuid(),
	title: z.string(),
	description: z.string().nullable().optional(),
	status: taskStatusSchema,
	priority: taskPrioritySchema,
	assignee_id: z.string().uuid().nullable().optional(),
	assignee_display_name: z.string().nullable().optional(),
	due_date: z.coerce.date().nullable().optional(),
	created_by: z.string().uuid(),
	created_at: z.coerce.date(),
	updated_at: z.coerce.date(),
});

export const createTaskSchema = z.object({
	title: z.string().min(1, "Title is required"),
	description: z.string().nullable().optional(),
	priority: taskPrioritySchema,
	assignee_id: z.string().nullable().optional(),
	due_date: z.string().nullable().optional(),
});

export const updateTaskSchema = z.object({
	title: z.string().min(1).optional(),
	description: z.string().nullable().optional(),
	status: taskStatusSchema.optional(),
	priority: taskPrioritySchema.optional(),
	assignee_id: z.string().nullable().optional(),
	due_date: z.string().nullable().optional(),
});
